import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileUploadDisComponent } from './file-upload-dis.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';



@NgModule({
  declarations: [
    FileUploadDisComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
  ],
  exports:[
    FileUploadDisComponent
  ]
})
export class FileUploadDisModule { }
